import * as React from 'react'
import useToken from './login/useToken';
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './login/authAzureConfig';
import { useHistory } from 'react-router-dom';

// Create an instance of PublicClientApplication
const msalInstance = new PublicClientApplication(msalConfig);
const Logout = () => {
    let routerHistory = useHistory();
    const { clearToken} = useToken();
    const { accounts, } = useMsal();
    React.useEffect(() => {
        localStorage.clear();
        if (accounts.length > 0) {
            clearToken();
            msalInstance.logoutRedirect();
        } else {
            clearToken();
            routerHistory.push("/login");
        }
    }, []);


    return (
        <>
        </>
    );
}
export default Logout;